import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XScroll, XText } from "IZOX/_X";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import { QFCheckBox, QFDropUpload } from "IZOX/BLOCKS/Libs/QForm/_gears";
import HTMLReactParser from "html-react-parser";
import { QForm } from "IZOX/BLOCKS/Libs";
import disclaimerEN from "../_disclaimerEN";
import disclaimerTC from "../_disclaimerTC";
import Styles from "__SYSDefault/Styles";

/**
 * @augments {Component<Props, State>}
 */
class RenewPolicyM extends Component {

  static propTypes = {
    selected: PropsType.array,
  }

  static defaultProps = {
    selected: [],
  }

  constructor(){
    super();
    this.state = {
      curStep: 0,
      showPolicyList: false,
      formValue: {
        
      }
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetPolicies();
    });
    document.addEventListener("mousedown", this._onClickOutSide);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(RenewPolicyM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this._onClickOutSide);
    this.setState = (state, callback) => {
      return;
    };
  }

  _toDisclaimer = () => {
    this.setState({
      curStep: 0
    });
  }

  _toUpload = () => {
    this.setState({
      curStep: 1
    });
  }

  _toSuccess = () => {
    this.setState({
      curStep: 2
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _close = (refresh = false) => {
    let {Refresh} = this.props;
    GFunc.CloseBackdrop();
    if(refresh){
      Refresh?.();
    }
  }

  _onAgreeChange = (formValue) => {
    this.setState({
      agreeForm: formValue
    });
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  _toSubmit = async () => {
    let {selected} = this.props;
    let {formValue} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/DCustomer/RenewPolicy", {
        docIDs: selected,
        formValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
  }

  _validAgree = () => {
    let {agreeForm} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(agreeForm, ["agreement"], "boolTrue");
    if(!valid) return false;
    return true;
  }

  _validateForm = () => {
    let {formValue} = this.state;
    let valid = ZValidate.CheckUploads(formValue, ["receipts", "documents"]);
    if(!valid) return false;
    return true;
  }

  _toPolicy = (_id) => {

  } 

  toList = () => {
    this.setState({
      showPolicyList: true
    });
  }

  _onClickOutSide = (e) => {
    if (this.ref && e.target.contains(this.ref)) {
      this._closeMenu();
    }
  }

  _closeMenu = () => {
    this.setState({
      showPolicyList: false
    });
  }

  renderDisclaimer(){
    let {agreeForm} = this.state;
    return (
      <QForm onChange={this._onAgreeChange} value={agreeForm}>
        <XScroll fullWidth spacing={20} pH={16}>
          <XText color={ColorX.CSS("Blood")}>
            {LocaleX.Parse({
              EN: "Please read this policy carefully to upload documents.",
              TC: "請仔細閱讀本政策以上傳文件。"
            })}
          </XText>
          <XText>
            {HTMLReactParser(LocaleX.Parse({
              EN: disclaimerEN,
              TC: disclaimerTC
            }))}
          </XText>
          <HStack spacing={5} HAlign="[" pV={20}>
            <QFCheckBox name="agreement"
              bColor={ColorX.CSS("pureWhite")}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Axit")} fontSize={14}>
              {LocaleX.Parse({
                EN: "I have read all terms and conditions above.",
                TC: "我已閱讀上述所有條款和條件。"
              })}
            </XText>
          </HStack>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._close, this._toUpload, {
          nextCap: {EN: "Submit", TC: "提交"},
          validateNext: this._validAgree
        })}
      </QForm>
    );
  }

  renderPolicyList(list){
    let mT = 60 + (Math.min(4, list.length) - 1) * 40;
    return (
      <XScroll style={{position: "absolute", 
        marginTop: mT, marginLeft: -100, zIndex: 300,
        maxHeight: 150}} width={120}
        shadow>
        <VStack bgColor={ColorX.CSS("pureWhite")} fitHeightToContent>
          {_.map(list, (o, i) => {
            return (
              <XButton color={ColorX.CSS("Axit")} padding={0} pH={16} pV={5}
                onPress={() => this._toPolicy(o._id)} key={i}> 
                <HStack>
                  <XText decoration="underline">
                    {`#${o.policyNo}`}
                  </XText>
                </HStack>
              </XButton>
            );
          })}
        </VStack>
      </XScroll>
    );
  }

  GetPolicies = async () => {
    let {selected} = this.props;
    let res = await ReqX.SendBE("/Web/DCustomer/GetPolicyNoByID", {
      docIDs: selected
    });
    let {Success, payload} = res;
    if(Success){
      this.setState({
        policyDocs: payload
      });
    }
  }

  renderTitleBar(){
    let {curStep} = this.state;
    return (
      <HStack pH={16} shadow flexShrink={0}>
        <XText fontSize={16} bold>
          {LocaleX.Parse(curStep === 0 ?
            {
              EN: "Disclaimer",
              TC: "免責聲明"
            }: 
            {
              EN: "Upload documents / receipts",
              TC: "上傳文件/收據"
            })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderSelected(){
    let {policyDocs, showPolicyList} = this.state;
    if(!policyDocs || policyDocs.length === 0) return;
    let _dis = _.slice(policyDocs, 0, 5);
    let _list = _.slice(policyDocs, 5);
    return (
      <HStack HAlign="[" pH={16} spacing={10} flexShrink={0}>
        <XText>
          {LocaleX.Parse({
            EN: `${policyDocs?.length} chosen ${policyDocs?.length > 1? "policies" : "policy"}`,
            TC: `${policyDocs?.length} 已選擇的保單`
          })}
        </XText>
        <HStack fitWidthToContent spacing={5}>
          {_.map(_dis, (o, i) => {
            return (
              <HStack fitWidthToContent spacing={5} key={i}>
                {i > 0 &&
                  <XText color={ColorX.CSS("Gray4")}> {"|"} </XText>}
                <XButton color={ColorX.CSS("Axit")} padding={0}
                  onPress={() => this._toPolicy(o._id)}> 
                  <HStack>
                    <XText decoration="underline">
                      {`#${o.policyNo}`}
                    </XText>
                  </HStack>
                </XButton>
              </HStack>
            );
          })}
          {_list.length > 0 &&
            <HStack fitWidthToContent spacing={5} forwardRef={e => this.ref = e}>
              <XText color={ColorX.CSS("Gray4")}> {"|"} </XText>
              <XButton color={ColorX.CSS("Axit")} padding={0}
                onPress={() => this._toList(_list)}> 
                <HStack>
                  <XText decoration="underline">
                    {`+${_list.length}`}
                  </XText>
                </HStack>
              </XButton>
              {showPolicyList && this.renderPolicyList(_list)}
            </HStack>}
        </HStack>
      </HStack>
    );
  }

  renderForm(readOnly = false){
    let {formValue, loading} = this.state;
    return (
      <QForm fullWidth fullHeight pH={16} onChange={this._onFormChange} 
        value={formValue}>
        <XScroll height={readOnly ? "auto" : 600} pH={16} pV={16} overflow={readOnly ? "visible" : "auto"}>
          <VStack fullWidth>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Upload documents",
                  TC: "上傳文件"
                })}
              </XText>
            </HStack>
            <QFDropUpload 
              fileSizeLimit={10}
              name="documents" 
              accept=".jpg,.png,.pdf,.jpeg"
              uploadZoneProps={{
                bgColor: ColorX.CSS("pureWhite"),
                fullWidth: true 
              }} 
              uploadZoneInnerProps={{
                fullWidth: true
              }}
              btnBgColor={ColorX.CSS("Axit")}
              color={ColorX.CSS("Stone")}
              previewColor={ColorX.CSS("Leaf")}
              previewZoneProps={{
                fullWidth: true,
                pB: 30
              }}
              instantUpload
              multiple
              fullWidth/>
          </VStack>
          <VStack fullWidth>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Stone")} bold>
                {LocaleX.Parse({
                  EN: "Upload receipts",
                  TC: "上傳收據"
                })}
              </XText>
            </HStack>
            <QFDropUpload
              fileSizeLimit={10}
              name="receipts" 
              accept=".jpg,.png,.pdf,.jpeg"
              uploadZoneProps={{
                bgColor: ColorX.CSS("pureWhite"),
                fullWidth: true 
              }} 
              uploadZoneInnerProps={{
                fullWidth: true
              }}
              previewColor={ColorX.CSS("Leaf")}
              btnBgColor={ColorX.CSS("Axit")}
              previewZoneProps={{
                fullWidth: true,
                pB: 30
              }}
              instantUpload
              multiple
              fullWidth/>
          </VStack>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._toDisclaimer, this._toSubmit, {
          nextCap: {EN: "Submit", TC: "提交"},
          validateNext: this._validateForm
        }, loading)}
      </QForm>
    );
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth height={550} spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold textAlign="|">
              {LocaleX.Parse({
                EN: "Policy Renewal is Submitted Successfully",
                TC: "保單更新已成功提交"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will be shown on the Policy Management page",
                TC: "將會顯示在保單管理頁面"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtn} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderMain(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderDisclaimer();
      case 1: return this.renderForm();
      case 2: return this.renderSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        fullWidth maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        <VStack fullWidth pT={16} fullHeight spacing={16}>
          {this.renderSelected()}
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

}

export default observer(RenewPolicyM);
